import { render } from "./UserInfo.vue?vue&type=template&id=2b7533af&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=2b7533af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b7533af"

export default script